

import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
} from './types';
import {
    DepartmentModal
} from './departmentmodal';

/**
 * Redux action creator to set the list
 * of departments
 * @param departmentstate departments information
 * @returns action instance
 */
export const setAction = (departmentstate: DepartmentModal[]):
    Action<typeof SET, DepartmentModal[]> => ({
        type: SET,
        payload: departmentstate,
    });
/**
 * Re-initialize the state
 * @returns action instance
 */
export const resetAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });

/**
 * Alias for setAction to match epic naming
 */
export const setDepartmentsAction = setAction;

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof resetAction>;

